import React from "react";

import Feature3Row from '../features/feature3-row';
import SectionContainer from '../containers/section-container';

export default class Feature3Container extends React.Component {
    render() {
        return (
            <div id="gtco-features-3">
                <SectionContainer>
                    <Feature3Row feature3Items={ this.props.feature3Items }/>                   
                </SectionContainer>
            </div>
        )
    };
}; 


// WEBPACK FOOTER //
// ./src/components/containers/feature3-container.jsx